class BusinessLicensePaymentFeeViewController extends MUIViewController
{
    static newInstance(): BusinessLicensePaymentFeeViewController {
        let vc = new BusinessLicensePaymentFeeViewController('licenses-detail-payment-fees-view');
        vc.initWithResource('layout/licenses/LicensesDetailPaymentFeesView.html');
        return vc;
    }

    private templateDropdown:MUIButton = null;
    private tableView:UITableView = null;
    private dataSource:BusinessLicensePaymentFeeDataSource = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.templateDropdown = MUIOutlet(this, "template-dd", "MUIButton");
        this.templateDropdown.setAction(this, this.showTemplateSelector);

        this.tableView = MUIOutlet(this, "table-view", "UITableView");

        this.dataSource = new BusinessLicensePaymentFeeDataSource();
        this.dataSource.initWithTableView( this.tableView );

        this.tableView.dataSource = this.dataSource;
        this.tableView.delegate = this.dataSource;
    }

    viewWillAppear(animate?){
        super.viewWillAppear(animate);
        this.updateUI();
    }

    private businessLicense:BusinessLicense = null;
    set item(item:BusinessLicense) {
        this.businessLicense = item;
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this.businessLicense == null) return;

        this.dataSource.business = this.businessLicense;

        // The template relationship is a fault until fetched with the license.
        DBHelper.queryObjectsWithCompletion("BusinessLicense", null, MIOPredicate.predicateWithFormat('identifier == "' + this.businessLicense.identifier + '"'), ["paymentFeeTemplate"], this, function(this:BusinessLicensePaymentFeeViewController, objects:BusinessLicense[]){
            this.updateTemplateUI();
        });
    }

    private updateTemplateUI(){
        let template = this.businessLicense.paymentFeeTemplate;
        this.templateDropdown.title = template != null ? template.name : MIOLocalizeString("CUSTOM", "CUSTOM");
        this.dataSource.readOnly = template != null;
    }

    private showTemplateSelector(){
        let vc = PaymentFeeTemplateSelectViewController.newInstance();
        vc.selectedTemplate = this.businessLicense.paymentFeeTemplate;
        vc.completionTarget = this;
        vc.completionBlock = this.templateDidSelect;

        vc.modalPresentationStyle = MUIModalPresentationStyle.Popover;
        let pc = vc.popoverPresentationController;
        pc.sourceRect = this.templateDropdown.frame;
        pc.sourceView = this.templateDropdown;

        this.presentViewController(vc, true);
    }

    private templateDidSelect(template:PaymentFeeTemplate){
        if (template == this.businessLicense.paymentFeeTemplate) return;

        if (template == null) {
            // Back to custom: unlink and keep the copied rows as a starting point.
            this.businessLicense.paymentFeeTemplate = null;
            DBHelper.saveMainContext();
            this.updateTemplateUI();
            return;
        }

        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("WARNING", "WARNING"), MIOLocalizeString("EXISTING_FEE_RULES_WILL_BE_REPLACED_BY_THE_TEMPLATE", "EXISTING FEE RULES WILL BE REPLACED BY THE TEMPLATE"), MUIAlertViewStyle.Default);

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("APPLY", "APPLY"), MUIAlertActionStyle.Destructive, this, function(this:BusinessLicensePaymentFeeViewController){
            this.applyTemplate(template);
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    private applyTemplate(template:PaymentFeeTemplate){
        // Make sure the template lines are loaded before copying them.
        DBHelper.queryObjectsWithCompletion("PaymentFeeTemplateLine", null, MIOPredicate.predicateWithFormat('template.identifier == "' + template.identifier + '" and deletedAt == null'), ["template"], this, function(this:BusinessLicensePaymentFeeViewController, lines:PaymentFeeTemplateLine[]){
            this.businessLicense.paymentFeeTemplate = template;
            template.applyToBusinessLicense(this.businessLicense, lines);
            DBHelper.saveMainContext();
            this.updateTemplateUI();
            this.dataSource.reloadLines();
        });
    }

    addPaymentFeeAction() {
        if (this.businessLicense == null) return;

        if (this.businessLicense.paymentFeeTemplate != null) {
            AppHelper.showErrorMessage(this, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("FEES_ARE_MANAGED_BY_A_TEMPLATE", "FEES ARE MANAGED BY A TEMPLATE. SWITCH TO CUSTOM TO EDIT."));
            return;
        }

        // The pricing matrix covers the standard rows; the add button creates
        // an ADVANCED rule for the exotic cases (exact countries, other
        // brands, legacy 3DS pricing).
        this.dataSource.addAdvancedFee();
    }
}
